import { useCallback } from 'react';
import useSWR from 'swr';
import { GridColDef, useGridApiRef } from '@mui/x-data-grid-pro';
import { dataGridCol } from '@shared/components/grid/common';
import { GridColNumber } from '@shared/components/grid/GridColNumber';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { ViewHeightWrapper } from '@styles/CommonStyles';
import { ILenderListItem } from '../shared/LenderControlsHeader';
import { requestUpdateLenderRank } from './queries';
import { lenderRankSchema } from './validation';

const columns: GridColDef[] = [
  dataGridCol('name', {
    flex: 1,
    headerName: 'Lender Name',
  }),
  dataGridCol('rank', {
    flex: 1,
    editable: true,
    headerName: 'Lender Rank',
    renderEditCell: (params) => <GridColNumber params={params} />,
  }),
  dataGridCol('subRank', {
    flex: 1,
    editable: true,
    headerName: 'Lender Sub Rank',
    renderEditCell: (params) => <GridColNumber params={params} />,
  }),
];

export const LenderRank = () => {
  const apiRef = useGridApiRef();
  const { data } = useSWR<ILenderListItem[]>(`/${SERVICES.LENDER}/lenders`, {
    fallbackData: [] as ILenderListItem[],
    revalidateOnMount: true,
  });

  const validateValues = useCallback(
    (row: ILenderListItem) => {
      for (const lr of apiRef.current.getRowModels().values()) {
        if (lr.rank === row.rank && lr.subRank === row.subRank && lr.id !== row.id) {
          Notistack.generalError('Lender Sub Rank should be unique within the same Lender Rank');
          return false;
        }
      }
      return true;
    },
    [data]
  );

  const gridActions = {
    onSave: (row: ILenderListItem) => requestUpdateLenderRank(row),
  };

  return (
    <ViewHeightWrapper>
      <PhoenixGrid
        strict
        withHeader
        canNotCopy
        noButton
        apiRef={apiRef}
        name="Lender Rank"
        pageSize={25}
        columns={columns}
        loading={!data}
        rows={data as ILenderListItem[]}
        actions={gridActions}
        validateSchema={lenderRankSchema}
        validateValues={validateValues}
      />
    </ViewHeightWrapper>
  );
};
